import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class SitePageService extends RestApiService{
  URL_PATH:string='/theme-page'; 
}
